import { type App } from 'vue';
import FloatingVue from 'floating-vue';
import { Vue3Mq } from 'vue3-mq';
import { MQ_OPTIONS } from '@/lib/vueMq';
import { i18n } from '@/lib/i18n';
import pinia from './pinia';
import router from './router';
import { popoverOptions } from '@/lib/floatingVue';
import initSentry from '@/lib/sentry';
import { appLoaderTop } from '@/directives';
import { isSafariBrowser } from '@/utils/browser';
import { APP_HEADER_COMPONENT } from './constants';

/**
 * Configure the give Vue application to include all the plugins that we use.
 */
export const configureVue = (app: App, { withRouter = true } = {}) => {
	app.use(i18n);
	app.use(pinia);
	// Installing the router replays the location captured when this module
	// loaded, via replaceState. On a page something else owns the URL of, that
	// silently rewrites it — so a router-less component can opt out.
	if (withRouter) {
		app.use(router);
	}
	app.use(FloatingVue, popoverOptions);
	app.use(Vue3Mq, MQ_OPTIONS);

	app.directive('app-loader-top', appLoaderTop);

	if (app._component.name === APP_HEADER_COMPONENT && !isSafariBrowser()) {
		initSentry(app);
	}

	return app;
};
